export default {
    login_register: 'Accedi/Registrati',
    booking_confirmation_title: 'Conferma prenotazione',
    booking_confirmation_body: 'Grazie per la tua prenotazione. Trova i dettagli della conferma qui sotto.',
    insurance_requirements_modal_disclaimer: `Effettuando questa prenotazione, confermo che: non ho avuto condanne o infrazioni stradali negli ultimi 5 anni. Non mi è stata rifiutata una proposta, annullata una polizza o rifiutato un rinnovo, né mi è stato richiesto di pagare un premio maggiorato o sono state imposte condizioni speciali da parte di una compagnia assicurativa. Non sono stato/a squalificato/a dalla guida. Non ho procedimenti giudiziari o indagini della polizia in corso. Non ho condanne per reati relativi a furto, frode o disonestà negli ultimi 5 anni. Non soffro di difetti della vista o dell’udito (non corretti da occhiali o apparecchio acustico), disturbi cardiaci, diabete, crisi epilettiche o qualsiasi infermità fisica o mentale. Non ho avuto incidenti negli ultimi 5 anni. Clicca {0} se non soddisfi questi requisiti.`,
    insurance_requirements_here: 'qui',
    insurance_requirements: 'Ho letto e compreso i {0}',
    ir: 'Requisiti assicurativi',
    location: 'Località',
    pickup_location: 'Luogo di ritiro',
    dropoff_location: 'Luogo di riconsegna',
    vehicle: 'Veicolo',
    pickup_and_dropoff: 'Ritiro e riconsegna (ora locale)',
    view_voucher: 'Visualizza voucher',
    identity_verification_body: 'Sarà necessario verificare la tua identità prima di ritirare il veicolo',
    identity_verification_title: 'Verifica identità',
    search_again: 'Cerca di nuovo',
    refrigerated: 'refrigerato',
    aircon_lower: 'aria condizionata',
    aircon: 'Aria condizionata',
    refrigeration: 'Refrigerato',
    not_available: 'Drive & Go è attualmente disponibile solo per persone con documenti di identità e patente dei seguenti paesi.',
    check_if_included: 'Verifica se il tuo paese è incluso.',
    included_in_booking: 'Incluso in questa prenotazione',
    cdw_with_excess: 'CDW con franchigia',
    theft_protection: 'Protezione furto con franchigia',
    risk_reduction: 'Riduzione del rischio',
    free_extras: 'Hai diritto a due extra gratuiti <br /> con questa prenotazione.',
    continue: 'Continua',
    luggage_large_short_label: 'G',
    luggage_medium_short_label: 'M',
    luggage_small_short_label: 'P',
    luggage_large_long_label: 'grande',
    luggage_medium_long_label: 'medio',
    luggage_small_long_label: 'piccolo',
    fuel_unspecified_label: 'non specificato',
    transmission_manual_label: 'Manuale',
    transmission_automatic_label: 'Automatico',
    make_a_booking: 'Effettua una prenotazione',
    pickup_date: 'Data di ritiro',
    dropoff_date: 'Data di riconsegna',
    driver_age: 'Conducente tra 30 e 65 anni',
    enter_driver_age: "Inserisci l'età del conducente",
    promo_code: 'Codice promozionale',
    search: 'Cerca',
    dropoff_date_cannot_be_before_pickup_date: 'La data di riconsegna non può essere precedente alla data di ritiro',
    pickup_date_cannot_be_in_the_past: 'La data di ritiro non può essere nel passato',
    pickup_time_cannot_be_in_the_past: "L'orario di ritiro non può essere nel passato",
    dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: "L'orario di riconsegna deve essere successivo a quello di ritiro se nello stesso giorno",
    vehicle_filters: 'Filtri veicolo',
    reset: 'Reimposta',
    transmission: 'Cambio',
    all: 'Tutti',
    manual: 'Manuale',
    auto: 'Automatico',
    passengers: 'Passeggeri',
    vehicle_type: 'Tipo di veicolo',
    filter: 'Filtra',
    vehicle_search: 'Ricerca veicolo',
    edit: 'Modifica',
    no_results: 'Nessun risultato corrisponde ai criteri selezionati.',
    small_cars: 'Auto piccole',
    medium_cars: 'Auto medie',
    large_cars: 'Auto grandi',
    estate_cars: 'Station wagon',
    suvs: 'SUV',
    mpvs: 'Monovolume',
    vans: 'Furgoni',
    camper_vans: 'Camper',
    premium: 'Premium',
    unspecified: 'non specificato',
    large: 'grande',
    medium: 'medio',
    small: 'piccolo',
    automatic: 'automatico',
    you_have_been_refunded: 'Ti è stato effettuato un rimborso.',
    please_customer_service: 'Per prenotare contatta il nostro servizio clienti.',
    contact_customer_service: 'Contatta il servizio clienti',
    booking_failed: 'La tua prenotazione non può essere elaborata in questo momento.',
    summary: 'Riepilogo',
    reforestation_and_protection: 'Sostieni la riforestazione e la protezione della foresta pluviale in Costa Rica',
    cost_of_rental: 'Costo del noleggio',
    to_pay_now: 'Da pagare ora',
    greenheart_donation: 'Donazione Green Heart',
    total_cost: 'Costo totale del noleggio',
    tc_agreement: 'Ho letto e compreso i {0}.',
    tc: 'Termini e condizioni',
    receive_offers: 'Vorrei ricevere offerte speciali via email.',
    donate: 'Sì, desidero donare {amount}',
    pay_now: 'Paga ora {amount}',
    driver_details: 'Dati del conducente',
    complete_driver_details: 'Completa i dati del conducente.',
    are_you_the_driver: 'Sei tu il conducente?',
    have_an_account: 'Hai già un account?',
    login: 'Accedi',
    or: 'oppure',
    first_name: 'Nome del conducente',
    last_name: 'Cognome del conducente',
    email: 'Indirizzo email',
    phone_number: 'Numero di cellulare',
    unable_to_save_driver_information: 'Impossibile salvare i dati del conducente. Riprova.',
    pay_online_now: 'Paga ora',
    day: 'Giorno',
    choose_location: 'Scegli una località',
    location_not_found: 'Spiacenti, non abbiamo trovato la località richiesta.',
    add: 'Aggiungi',
    remove: 'Rimuovi',
    free_extra: 'Extra gratuito',
    free: 'GRATIS!',
    fast_track_notice: "Per questo servizio si applicano restrizioni sull'origine dei documenti. Disponibile solo per persone con documenti di",
    complete_booking: 'Completa prenotazione',
    choose_card: 'Scegli una carta o aggiungine una nuova.',
    add_billing_details: 'Aggiungi i dettagli di fatturazione.',
    card_number: 'Numero carta',
    card_holder_name: 'Nome intestatario',
    card_exp: 'MM / AA',
    card_cvc: 'CVC',
    save_card: 'Salvare la carta?',
    amount_charged: "L'importo verrà addebitato sulla tua carta",
    payment_confirmation: 'Conferma prenotazione e paga',
    payment_methods: 'metodi di pagamento disponibili',
    use_saved_card: 'x usa carta salvata',
    use_different_card: "+ usa un'altra carta",
    book_now: 'Prenota ora',
    minimum_age: 'Solo per maggiori di {age} anni',
    excess_liability: 'Franchigia',
    security_deposit: 'Deposito cauzionale',
    fuel_policy: 'Politica carburante',
    like_for_like: 'Come trovato',
    full_to_full: 'Pieno a pieno',
    miles_per_rental: '{mileage} miglia gratuite per noleggio',
    km_per_rental: '{mileage} km gratuiti per noleggio',
    unlimited_mileage: 'Chilometraggio illimitato',
    unlimited_mileage_km: 'Km illimitati',
    non_amendable: 'Non modificabile',
    non_refundable: 'Non rimborsabile',
    free_cancellation_until: 'Cancellazione gratuita fino a',
    cancellation_in_line_with: 'Cancellazione secondo',
    tcs: 'Termini e condizioni',
    free_extras_on_collection: 'Due extra gratuiti al ritiro',
    glass_and_tyres_covered: 'Vetri e pneumatici coperti',
    number_of_passengers: 'Numero di passeggeri',
    number_of_bags: 'Numero di bagagli',
    fuel_type: 'Tipo di carburante',
    co2: 'CO2',
    book_type: 'Prenota {type}',
    processing: 'Elaborazione',
    actual_price: 'Prezzo effettivo',
    tooltip: 'Il prezzo in {currencyCode} è una stima basata sul tasso di cambio, il prezzo in {currency} è vincolante.',
    deposit: 'Deposito',
    pay_online: 'Paga ora',
    pay_online_without_extras: 'Prezzo del noleggio',
    extras_on_arrival: "Extra all'arrivo",
    insurance_on_arrival: "Riduzione rischio - Paga all'arrivo",
    insurance_online: 'Riduzione rischio - Paga ora',
    extras_online: 'Extra - paga ora',
    green_heart_donation: 'Donazione Green Heart',
    why_use_drive_and_go: 'Perché scegliere Drive & Go?',
    straight_to_car: "Direttamente all'auto",
    no_queues: 'Nessuna coda',
    self_checkout: 'Check-out automatico',
    cant_lose_key: 'Non puoi perdere la chiave',
    online_id_check: 'Verifica ID online',
    phone_as_key: 'Telefono come chiave',
    premiumplus_benefits_includes: 'Include anche i vantaggi Premium Plus+',
    book_drive_go: 'Prenota Drive & Go',
    distance_allowance: 'Distanza consentita',
    duration: 'Durata',
    view_more_bookings: 'Vedi altre prenotazioni',
    to_pay_on_arrival: "Da pagare all'arrivo",
    pay_on_arrival: "Paga all'arrivo",
    unlimited: 'Illimitato',
    return_date: 'Data di riconsegna',
    postcode: 'CAP',
    country: 'Paese',
    drive_and_go: {
        drive_and_go: 'Drive And Go',
        available_countries: 'Drive & Go è attualmente disponibile solo per persone con documenti di identità e patente dei seguenti paesi:',
        drive_and_go_today: 'Prenota Drive & Go per oggi!',
        drive_and_go_shortened: 'Drive & Go',
        why_use_drive_and_go: 'Perché scegliere Drive & Go?',
        straight_to_car: "Direttamente all'auto",
        no_queues: 'Nessuna coda',
        self_checkout: 'Check-out automatico',
        cannot_lose_the_key: 'Non puoi perdere la chiave',
        online_id_check: 'Verifica ID online',
        phone_as_a_key: 'Telefono come chiave',
        premium_plus_benefits_also_included: 'Include anche i vantaggi Premium Plus+',
        book_drive_and_go: 'Prenota Drive & Go',
    },
    car_and_camp: {
        tent_and_equipment: 'Tenda e attrezzatura',
        quick_and_easy: 'Montaggio rapido e facile',
        travel_freedom: 'Libertà di viaggio',
        affordable_campervan_alternative: 'Alternativa economica al camper',
        lightweight_and_compact: 'Leggero e compatto',
        fully_insured: 'Completamente assicurato',
    },
    my_bookings: 'La mia prenotazione',
    no_bookings: 'Nessuna prenotazione',
    my_profile: 'Il mio profilo',
    no_bookings_to_display: 'Nessuna prenotazione da mostrare.',
    search_great_car_rental_deals: 'Cerca fantastiche offerte di noleggio auto per il tuo prossimo viaggio.',
    odometer_at_collection: 'Contachilometri al ritiro',
    fuel_at_collection: 'Carburante al ritiro',
    start_check_in: 'Inizia check-in',
    start_collection: 'Inizia ritiro',
    recent_bookings: 'Prenotazione recente',
    damage: {
        updated_damage_report_submitted: 'Un rapporto danni aggiornato è stato inviato. Un membro del nostro team di assistenza clienti ti contatterà se necessario.',
        add_additional_damage: 'Aggiungi danno aggiuntivo',
        you_may_report_additional_damage_up_to: 'Puoi segnalare danni aggiuntivi fino a 24 ore dopo la riconsegna del veicolo',
        specify_damage: 'Specifica il danno',
        please_choose_the_area_and_type_of_damage: "Scegli l'area e il tipo di danno",
        type_of_damage: 'Tipo di danno',
        is_this_more_than_5_cm: 'È superiore a 5 cm?',
        please_take_or_select_a_photo: 'Scatta o seleziona una foto',
        please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Scatta una foto assicurandoti che il danno sia chiaramente visibile',
        if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: " Se necessario puoi aggiungere un'altra foto, seleziona l'icona per aggiungerla",
        save_image: 'Salva immagine',
        save_images: 'Salva immagini',
        damage_saved_successfully: 'Danno salvato con successo',
        add_photo: 'Aggiungi foto',
    },
    checkout: {
        start_collection: 'Inizia ritiro',
        collect_vehicle: 'Ritira veicolo',
        we_will_let_you_know_the_details: 'Ti comunicheremo la posizione e i dettagli per trovare il veicolo a noleggio.',
        inspect: 'Ispeziona',
        we_will_ask_for_four_photos_from_each_corner: 'Ti chiederemo quattro foto da ogni angolo del veicolo e di eventuali nuovi danni non già segnalati.',
        fuel_and_milage: 'Carburante & chilometraggio',
        you_confirm_the_readings_at_the_start_of_your_hire: "Confermi i dati del contachilometri e del carburante all'inizio del noleggio.",
        sign: 'Firma',
        sign_the_rental_agreement: 'Firma il contratto di noleggio.',
        away_you_go: 'Buon viaggio',
        you_are_free_to_take_to_the_road: 'Sei pronto per partire!',
        collect_your_vehicle: 'Ritira il tuo veicolo',
        get_directions: 'Ottieni indicazioni',
        hide_directions: 'Nascondi indicazioni',
        local_time: 'ora locale',
        tel: 'Tel',
        getting_to_the_location: 'Come raggiungere la località',
        get_vehicle_details: 'Dettagli veicolo',
        view_map: 'Visualizza mappa',
        unlock_vehicle_and_continue: 'Sblocca veicolo & continua',
        unable_to_connect_to_vehicle: 'Impossibile connettersi al veicolo',
        we_were_unable_to_connect_to_the_vehicle_please_check: 'Impossibile connettersi al veicolo - verifica di essere vicino al veicolo corretto e riprova.',
        we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'Impossibile trovare la prenotazione del veicolo. Riprova più tardi.',
        odometer_and_fuel: 'Contachilometri & carburante',
        odometer: 'Contachilometri',
        please_confirm_the_odometer_and_fuel_readings: 'Se possibile, conferma i dati del contachilometri e del carburante.',
        the_odometer_field_is_required: 'Il campo contachilometri è obbligatorio',
        and_must_be_greater_than_the_checkout_odometer: 'e deve essere superiore al contachilometri al ritiro',
        confirm: 'Conferma',
        please_take_a_photo_from_each_corner_of_the_vehicle: 'Scatta una foto da ogni angolo del veicolo',
        pre_existing_damage: 'Danni preesistenti',
        no_pre_existing_damage: 'Nessun danno preesistente.',
        new_damage: 'Nuovo danno',
        add_additional_damage: 'aggiungi danno aggiuntivo',
        no_new_damage_to_report: 'Nessun nuovo danno da segnalare',
        checkout_complete: 'Ritiro completato',
        start_rental: 'Inizia noleggio',
        congratulations_name_it_is_time_to_take_to_the_road: 'Congratulazioni {customer_name}, è ora di partire!',
        we_are_unable_to_complete_your_vehicle_checkout: 'Impossibile completare il ritiro del veicolo.',
        please_do_the_following: 'Per favore, fai quanto segue',
        remove_all_belonging_and_lock_the_vehicle: 'Rimuovi tutti gli oggetti e chiudi il veicolo.',
        lock_vehicle: 'Chiudi veicolo',
        once_you_have_contacted_customer_services: 'Dopo aver contattato il servizio clienti',
        vehicle_location: 'Posizione veicolo',
        collect_your: 'Ritira il tuo',
        from: 'Da',
        key_in_glove_box: 'la tua chiave si trova nel vano portaoggetti',

        keyholder: {
            not_detected: 'Chiave non rilevata nel portachiavi',
            not_detected_please_try_again: 'Inserisci la chiave nel portachiavi e riprova.',

            not_installed: 'Portachiavi non installato',
            not_installed_please_contact_customer_service: 'Il portachiavi non è installato, contatta il servizio clienti.',
        },
        keyring: {
            look_up_failed: 'Ricerca portachiavi fallita',
            look_up_failed_please_contact_customer_service: 'Ricerca portachiavi fallita, contatta il servizio clienti.',
        },
        key: {
            invalid: 'Chiave non valida',
            invalid_please_contact_customer_service: 'La tua chiave non è valida, contatta il servizio clienti.',

            expired: 'Chiave scaduta',
            expired__please_contact_customer_service: 'La tua chiave è scaduta, contatta il servizio clienti.',
        },
    },
    checkin: {
        start_check_in: 'Inizia check-in',
        vehicle_location: 'Posizione veicolo',
        tell_us_where_you_have_parked: 'Dicci dove hai parcheggiato il veicolo.',
        fuel_and_milage: 'Carburante & chilometraggio',
        you_confirm_the_readings_at_the_end_of_your_hire: 'Confermi i dati del contachilometri e del carburante alla fine del noleggio.',
        inspect: 'Ispeziona',
        we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage:
            'Ti chiederemo quattro foto da ogni angolo del veicolo e di eventuali nuovi danni avvenuti durante il noleggio.',
        lock: 'Chiudi',
        check_you_have_left_no_belonging_then_lock_the_vehicle: 'Controlla di non aver lasciato oggetti e chiudi il veicolo.',
        please_tell_us_where_you_have_parked_the_vehicle: 'Dicci dove hai parcheggiato il veicolo',
        once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Una volta chiuso il veicolo, non potrai più riaprirlo.',
        name_please_check_you_have_left_no_belongings_then_lock_the_vehicle:
            '{first_name}, controlla di non aver lasciato oggetti, chiudi il veicolo e, se necessario, restituisci la chiave fisica nel portachiavi.',
        lock_vehicle: 'Chiudi veicolo',
        complete_check_in: 'Completa check-in',
        inspection: 'Ispezione',
        complete_vehicle_check_in: 'Completa check-in veicolo',
        we_are_unable_to_complete_your_vehicle_check_in: 'Impossibile completare il check-in del veicolo.',
        please_contact_customer_services: 'Contatta il servizio clienti',
        once_you_have_contacted_customer_services: 'Dopo aver contattato il servizio clienti',
        please_amend_odometer_to_be_greater_than: 'Modifica il contachilometri a un valore superiore a {odometer_value}',
    },
    rental_agreement: {
        rental_agreement: 'Contratto di noleggio',
        agreement_between: 'Contratto tra',
        and: 'e',
        sign_rental_agreement: 'Firma il contratto di noleggio',
        i_have_read_and_understood_the_terms_and_conditions: 'Ho letto e compreso i Termini e Condizioni e accetto lo stato del veicolo',
    },
    additional_options: 'Opzioni aggiuntive',
    booking_details: 'Dettagli prenotazione',
    price_for_x_days: 'Prezzo per {qty_of_days} giorno | Prezzo per {qty_of_days} giorni',
    cancelled: 'Cancellata',
    upcoming: 'In arrivo',
    active: 'Attiva',
    full_insurance_no_deposit: 'Assicurazione completa & nessun deposito richiesto',
    excess: '{amount} franchigia',
    deposit: '{amount} deposito',
    included_daily_distance: '{distance} {unit} al giorno',
    miles: 'miglia',
    kilometers: 'chilometri',
    collection_details_title: 'Dettagli ritiro',
    collection_details_not_found: 'Nessun dettaglio di ritiro definito per questa località',
    free_cancellation: 'Cancellazione gratuita',
    no_deposit: 'Nessun deposito',
    benefit_from: 'Approfitta di',
    for_only_per_day: 'A soli {price} al giorno',
    upgrade_mee: 'UpgradeMee',
};
